import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnFileUploadTemplateOptionsInterface } from './file-upload-template-options.interface';

export interface ISnFileUploadFormFieldConfigInterface extends FormlyFieldConfig {
  type: 'file-upload';
  templateOptions?: ISnFileUploadTemplateOptionsInterface;
}
